module.exports = __webpack_public_path__ + "static/media/collegepredpopup.2b4b3bf0.png";